<app-community-switcher></app-community-switcher>

@if (userMenu) {
    <section class="block">
        <div class="block__title">
            <span class="icon block__icon" [ngClass]="userMenu.icon"></span>
            <span class="block__text">{{ userMenu.title | translate | truncate: 40 }}</span>
        </div>
    </section>

    @for (userItem of userMenu.items; track userItem) {
        <app-left-menu-block [menu]="userItem"></app-left-menu-block>
    }
}

@if (communityMenu) {
    <section class="block">
        <div class="block__title">
            <span class="icon block__icon" [ngClass]="communityMenu.icon"></span>
            <span class="block__text">{{ communityMenu.title | translate | truncate: 40 }}</span>
        </div>
    </section>

    @for (communityItem of communityMenu.items; track communityItem) {
        <app-left-menu-block [menu]="communityItem"></app-left-menu-block>
    }
}

@if (superAdminMenu) {
    <section class="block">
        <div class="block__title">
            <span class="icon block__icon" [ngClass]="superAdminMenu.icon"></span>
            <span class="block__text">{{ superAdminMenu.title | translate | truncate: 40 }}</span>
        </div>
    </section>

    @for (superAdminItem of superAdminMenu.items; track superAdminItem) {
        <app-left-menu-block [menu]="superAdminItem"></app-left-menu-block>
    }
}
